/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Household_RegisterInputs */

const fr_household_register = /** @type {(inputs: Household_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inscrire`)
};

/**

* @param {Household_RegisterInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const household_register = /** @type {((inputs?: Household_RegisterInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Household_RegisterInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_household_register(inputs)
});